import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const October = () => {
    return (
        <Fragment>{SkipDays(4, 6, [])}</Fragment>  
    )
}